import NewCatalogModal from "./NewCatalogModal";

export default NewCatalogModal;
